import React, { Fragment } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Footer from "../components/Footer";

function PrivateRoutes() {
  const loginUser = sessionStorage.getItem("loginUser");
  return loginUser ? (
    <Fragment>
      <Outlet />
      <Footer />
    </Fragment>
  ) : (
    <Navigate to="sign-in" />
  );
}

export default PrivateRoutes;
